<template>
  <GestionBodegas />
</template>
<script>
import GestionBodegas from "./components/GestionBodegas";
export default {
  components: { GestionBodegas },
  mounted() {
    if (!this.$store.getters["auth/isLogged"]) {
      this.$router.push({ name: "Login" });
    }
  },
};
</script>
